<template>
	<div
		class="fixed z-50 inset-0 overflow-y-auto"
		aria-labelledby="modal-title"
		role="dialog"
		aria-modal="true"
	>
		<div
			class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
		>
			<transition name="fade">
				<div
					class="fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity"
					aria-hidden="true"
					v-if="open"
					ref="overlay"
					v-on:click="close()"
				></div>
			</transition>

			<!-- This element is to trick the browser into centering the modal contents. -->
			<span
				class="hidden sm:inline-block sm:align-middle sm:h-screen"
				aria-hidden="true"
				>&#8203;</span
			>

			<!-- Here comes the true content -->
			<transition name="zoomin">
				<div
					class="inline-block align-top bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:align-top sm:my-[7.5%]"
					:class="
						small
							? 'w-72 sm:max-w-lg sm:w-full'
							: 'sm:max-w-lg sm:w-full md:max-w-screen-md'
					"
				>
					<!-- header -->
					<slot name="header">
						<div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
							<button
								type="button"
								class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
								v-on:click="close()"
							>
								<span class="sr-only">{{ __("Close") }}</span>
								<ui-icon name="x" class="h-6 w-6" stroke-width="2" />
							</button>
						</div>
					</slot>

					<!-- main content -->
					<!-- important: this default content uses an alert icon;
                         do we want the default modal to be an error? -->
					<slot name="full-content">
						<div class="p-6">
							<div class="sm:flex sm:items-start">
								<!-- sm:h-10 sm:w-10 -->
								<div
									:class="[
										'mx-auto flex-shrink-0 flex items-center justify-center h-16 w-16 rounded-full sm:mx-0',
										alertStyle == 'alert' ? 'bg-red-100' : 'bg-green-100',
									]"
								>
									<!-- sm:h-5 sm:w-5 -->
									<ui-icon
										name="alert-triangle"
										class="h-8 w-8 text-red-600"
										stroke-width="2"
										v-if="alertStyle == 'alert'"
									/>
									<ui-icon
										name="pen-tool"
										class="h-8 w-8 text-green-600"
										stroke-width="2"
										v-else-if="alertStyle == 'accept-offer'"
									/>
									<ui-icon
										name="alert-triangle"
										class="h-8 w-8 text-green-600"
										stroke-width="2"
										v-else
									/>
								</div>
								<div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
									<h3
										class="text-2xl font-medium text-gray-900"
										id="modal-title"
									>
										{{ __(title) }}
									</h3>

									<div class="mt-2">
										<slot></slot>
										<!-- slot slot slot slot slot slot slot -->
									</div>
								</div>
							</div>
						</div>
					</slot>

					<!-- footer buttons -->
					<slot name="buttons">
						<div
							class="pb-6 px-6 flex flex-col sm:flex-row-reverse sm:items-end gap-y-3 gap-x-3"
						>
							<!-- class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm" -->
							<ui-button
								:class="[
									'w-full sm:w-auto text-lg',
									alertStyle == 'alert'
										? 'bg-red-500 hover:bg-red-600'
										: alertStyle == 'accept-offer'
										? 'bg-green-600 hover:bg-green-600'
										: 'bg-green-500 hover:bg-green-600',
								]"
								type="primary"
								v-on:click="confirmModal()"
								>{{ __(confirmLabel) }}</ui-button
							>
							<!-- class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 sm:mt-0 sm:w-auto sm:text-sm" -->
							<ui-button
								type="secondary"
								class="w-full sm:w-auto text-lg"
								v-on:click="dismissModal()"
								v-if="hasDismissButton"
								>{{ __(dismissLabel) }}</ui-button
							>
						</div>
					</slot>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
/**
 * @deprecated abgelöst durch Modal-Dialog
 *
 */
export default {
	props: {
		title: {
			type: String,
			required: false,
			default: "Are you sure?",
		},
		confirmLabel: {
			type: String,
			required: false,
			default: "Yes",
		},
		dismissLabel: {
			type: String,
			required: false,
			default: "No",
		},
		small: {
			type: Boolean,
			default: false,
		},
		alertStyle: {
			type: String,
			default: "alert", // or check
		},
		hasDismissButton: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			open: false,
		};
	},
	mounted() {
		this.open = true;
	},
	methods: {
		close() {
			let ref = this.$refs.overlay,
				that = this;
			/*
           this.$refs.overlay.addEventListener('transitionend', () => {
               this.$emit('close');
           });
           this.$nextTick(function() {
               this.open = false;
           });
           */
			setTimeout(function () {
				that.$emit("close");
			}, 300);
			this.$nextTick(function () {
				this.open = false;
			});
		},
		confirmModal() {
			this.$emit("confirm");

			this.close();
		},
		dismissModal() {
			this.$emit("dismiss");
			this.close();
		},
	},
};
</script>
